import { AdyenCheckout, Card, Dropin } from '@adyen/adyen-web/auto';
import { toast } from '@pmi/dsm-react';
import { useEffect, useRef } from 'react';
// import PrimaryPaymentMethodCheckbox from './PrimaryPaymentMethodCheckbox';
import { AdyenProps } from '../../models/PaymentModels';
import usePaymentFormStartTracking from './usePaymentFormStartTracking';

const ADYEN_PAYMENT_METHODS = [
  {
    brands: ['amex', 'cup', 'diners', 'discover', 'jcb', 'mc', 'visa', 'vpay'],
    name: 'Cards',
    type: 'scheme',
  },
];

function Adyen({
  id,
  editing,
  // fieldNames,
  clientKey,
  environment,
  handleFormStart,
  refs,
  onSubmitCallback,
}: AdyenProps) {
  const dropinContainerRef = useRef<HTMLDivElement>(null);
  const { adyenDropinRef } = refs;
  const containerId = `${id}-adyen-container`;

  // const title = 'Credit or Debit Card';

  useEffect(() => {
    const initAdyen = async () => {
      if (editing) return;

      if (!dropinContainerRef.current) {
        console.error('Adyen SDK failed to mount. Dropin container not found.');
        toast('Something went wrong. Please try again.', 'danger');
        return;
      }

      const adyenCheckout = await AdyenCheckout({
        amount: {
          currency: 'USD',
          value: 0,
        },
        analytics: { enabled: false },
        clientKey,
        environment,
        locale: window?.navigator.language || 'en-US',
        countryCode: 'US',
        paymentMethodsResponse: {
          paymentMethods: ADYEN_PAYMENT_METHODS,
          storedPaymentMethods: [],
        },
        showPayButton: false,
        onEnterKeyPressed: (state, component) => {
          console.log('Enter key pressed:', state, component);
          // component.submit();
        },
        onSubmit: onSubmitCallback,
        onAdditionalDetails: (state, component) => {
          console.log('Additional details required:', state, component);
        },
        onPaymentCompleted: (result, component) => {
          console.log('Payment completed:', result, component);
        },
        onPaymentFailed: (error, component) => {
          console.error('Payment failed:', error, component);
          toast('Payment failed. Please try again.', 'danger');
        },
      });

      const dropin = new Dropin(adyenCheckout, {
        // Include the payment methods that imported.
        paymentMethodComponents: [Card],
        paymentMethodsConfiguration: {
          card: {
            onFieldValid: (state) => {
              console.log('Card field valid state:', state);
            },
            hasHolderName: true,
            holderNameRequired: true,
            challengeWindowSize: '05',
            onAllValid: (state) => {
              console.log('All card fields valid:', state);
            },
            onEnterKeyPressed: () => {},
            // hideCVC: fields?AdyenCardHideCVC?.value || false,
            isDropin: true,
            // billingAddressRequired: true,
            name: 'Credit or debit card',
            enableStoreDetails: true,
          },
        },
        // Mount it to the container you created.
      }).mount(dropinContainerRef.current);

      adyenDropinRef.current = dropin;
    };

    initAdyen();

    return () => {
      adyenDropinRef.current?.unmount();
      adyenDropinRef.current = null;
      dropinContainerRef.current = null;
    };
  }, []);

  usePaymentFormStartTracking({
    editing,
    handleFormStart,
    containerId,
  });

  return (
    <div id={containerId} className="flex flex-col gap-y-6">
      {!editing && (
        <div data-private id="dropin-container" ref={dropinContainerRef} />
      )}
      {/* <PrimaryPaymentMethodCheckbox
        id={id}
        name="primaryPaymentMethod"
        editing={editing}
      /> */}
    </div>
  );
}

export default Adyen;
